import { HelperStoreService } from 'app/services/store/helper-store.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { GeneralUser } from '@co-assist/library';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private helpers: Array<GeneralUser> = [];

    constructor(
        private helperStoreService: HelperStoreService
    ) { }

    initData() {
        return this.helperStoreService.helpers$.pipe(
            map(res => {
                this.helpers = res ? res.filter(h => !!h) : [];
            })
        )
    }
}
